import axios from "axios";
import { useMutation, useQuery } from "react-query";
import { API_URL, securityHeaders } from "../Constants";

const profileEdit = (values) => {
  // return axios.post(API_URL + `/api/profileEdit`, values);

  return axios.post(API_URL + `/api/Users/CreateUser`, values, {
    headers: securityHeaders,
  });
};

export const useProfileEdit = () => {
  return useMutation(profileEdit);
};

const changePassword = (value) => {
  // return axios.post(API_URL + `/api/Users/ResetUserPassword`, value);

  return axios.post(API_URL + `/api/Users/ResetUserPassword`, value, {
    headers: securityHeaders,
  });
};

export const useChangePassword = () => {
  return useMutation(changePassword);
};

const userInfo = async () => {
  return await axios.get(API_URL + `/api/RolePage/GetAuthenticatedUser`, {
    headers: securityHeaders,
  });
};

export const useUserInfo = () => {
  return useQuery({
    queryKey: ["UserById"],
    queryFn: () => userInfo(),
    enabled: true,
  });
};
